import 'swo-ciam-common-react/dist/style-overrides.scss';
import '@src/core/styles/header-overrides.scss';
import '@src/core/i18n/config';

import ReactDOM from 'react-dom';
import { StrictMode } from 'react';
import { ToasterComponent } from 'swo-ciam-common-react';

import { RootComponent } from './root.component';

ReactDOM.render(
  <StrictMode>
    <ToasterComponent />
    <RootComponent />
  </StrictMode>,
  document.getElementById('root')
);
